import React from 'react';

const ProductMainImgWrapper = ({ thumbnail }) => {
  return (
    <figure className={'product-main-img-wrapper'}>
      <img
        fetchpriority='high'
        src={thumbnail || '/images/img_no_img.png'}
        alt='product detail image'
        className={'product-main-img'}
        onError={(e) => {
          e.target.onerror = null; // onError 이미지도 실패했을 때 무한루프 방지
          e.target.src = '/images/img_no_img.png';
        }}
        decoding={'async'}
      />
    </figure>
  );
};

export default ProductMainImgWrapper;
